<template>
    <fragment for="subject in subjects">
        <fragment v-for="subject in subjects" :key="subject._uid">
            <td colspan="3" v-if="subject.type === 'insurer'">
                <insurer-annotations
                    :subject="subject"
                    :convention="convention"
                    :insurers="insurers"
                    :annotationOptions="annotationOptions"
                />
            </td>
            <td colspan="3" v-else-if="subject.type === 'indemnity'">
                <indemnity-annotations
                    :subject="subject"
                    :convention="convention"
                    :annotationOptions="annotationOptions"
                />
            </td>
            <td colspan="3" v-else-if="subject.type === 'rates'">
                <rates-annotations
                    :subject="subject"
                    :convention="convention"
                    :annotationOptions="annotationOptions"
                />
            </td>
        </fragment>
    </fragment>
</template>

<script>
import { Fragment } from "vue-fragment";
import InsurerAnnotations from "./subjects-body-by-types/insurer/InsurerAnnotations.vue";
import IndemnityAnnotations from "./subjects-body-by-types/indemnity/IndemnityAnnotations.vue";
import RatesAnnotations from "./subjects-body-by-types/rates/RatesAnnotations.vue";

export default {
    components: { Fragment, IndemnityAnnotations, InsurerAnnotations, RatesAnnotations },
    props: ["subjects", "convention", "insurers", "annotationOptions"],
};
</script>

<style scoped lang="sass">
</style>